import "./style.css";

import { news } from "./data/newsdb.js";
import { comments } from "./data/commentsdb";
import { images } from "./data/imagedb.js";

function filterSetting(item, filterSettings) {
  const titleFilter =
    item.title.toLowerCase().includes(filterSettings.search.toLowerCase()) ||
    item.ingress?.toLowerCase().includes(filterSettings.search.toLowerCase()) ||
    item.content?.toLowerCase().includes(filterSettings.search.toLowerCase());
  const dataFilter = filterSettings.year
    ? new Date(item.publishDate).getFullYear() === parseInt(filterSettings.year)
    : true;

  const postFilter = filterSettings.post
    ? item.id === parseInt(filterSettings.post)
    : true;

  return postFilter && titleFilter && dataFilter;
}

function showContent(page, size, filterSettings) {
  const newsWrapper = document.getElementById("news");

  const newsItems = news
    .filter((item) => filterSetting(item, filterSettings))
    .sort(function (a, b) {
      return new Date(b.publishDate) - new Date(a.publishDate);
    });

  if (page * size + size >= newsItems.length) {
    document.getElementsByClassName("loadMore")[0].style.display = "none";
  } else {
    document.getElementsByClassName("loadMore")[0].style.display = "block";
  }

  newsItems.slice(page * size, page * size + size).forEach((element) => {
    const article = document.createElement("article");
    const metadata = document.createElement("div");
    const title = document.createElement("h3");
    const publishDate = document.createElement("time");
    const author = document.createElement("address");
    const commentCount = document.createElement("span");
    const link = document.createElement("a");
    const titleLink = document.createElement("a");
    const ingress = document.createElement("h4");
    const content = document.createElement("p");
    const imageWrapper = document.createElement("div");
    const commentsWrapper = document.createElement("div");
    const commentsTitle = document.createElement("H4");

    metadata.className = "metadata";
    ingress.className = "ingress";
    imageWrapper.className = "images";
    commentsWrapper.className = "comments";

    const elementComments = comments.filter(
      (item) => item.articleId === element.id
    );

    if (elementComments.length) {
      elementComments.forEach((comment) => {
        const commentElement = document.createElement("div");
        const commentHeader = document.createElement("header");
        const authorElement = document.createElement("address");
        const postedElement = document.createElement("time");
        const titleElement = document.createElement("h4");
        const bodyElement = document.createElement("p");

        authorElement.innerText = comment.author;
        postedElement.innerText = `${new Date(
          comment.publishDate
        ).toLocaleDateString("nb-NO")} – ${new Date(
          comment.publishDate
        ).toLocaleTimeString("nb-NO")}`;
        titleElement.innerText = comment.title;
        bodyElement.innerText = comment.content;

        commentHeader.appendChild(authorElement);
        commentHeader.appendChild(postedElement);
        commentElement.appendChild(commentHeader);
        commentElement.appendChild(titleElement);
        commentElement.appendChild(bodyElement);
        commentsWrapper.appendChild(commentElement);
      });
    }

    const elementImages = images[element.id];

    if (elementImages) {
      for (let i = 0; i <= 6; i += 2) {
        const imageUrl = elementImages[`image${i}Url`];
        const imageName = elementImages[`image${i}Name`];

        if (imageUrl) {
          const figureWrapper = document.createElement("figure");
          const captionElement = document.createElement("figcaption");
          const imageElement = document.createElement("img");

          imageElement.src = `images/${imageUrl}`;
          imageElement.alt = imageName;

          captionElement.innerText = imageName;

          figureWrapper.appendChild(imageElement);
          figureWrapper.appendChild(captionElement);
          imageWrapper.appendChild(figureWrapper);
        }
      }
    }

    title.innerText = element.title;
    author.innerText = `Skrevet av: ${element.author}`;
    publishDate.innerText = `${new Date(element.publishDate).toLocaleDateString(
      "nb-NO"
    )} – ${new Date(element.publishDate).toLocaleTimeString("nb-NO")}`;
    commentCount.innerText = `Kommentarer: ${elementComments.length}`;
    link.innerText = `Mer info [${element.url}]`;
    link.href = element.url;
    link.target = "blank";
    ingress.innerText = element.ingress;
    content.innerText = element.content ? element.content : null;

    commentsTitle.innerText = "Kommentarer";

    titleLink.href = `${window.location.pathname}?post=${element.id}`;

    titleLink.appendChild(title);
    article.appendChild(titleLink);
    metadata.appendChild(author);
    metadata.appendChild(publishDate);
    metadata.appendChild(commentCount);
    // element.url && metadata.appendChild(link);
    article.appendChild(metadata);
    article.appendChild(ingress);
    elementImages && article.appendChild(imageWrapper);
    content && article.appendChild(content);
    elementComments.length && commentsWrapper.prepend(commentsTitle);
    elementComments.length && article.appendChild(commentsWrapper);
    newsWrapper.appendChild(article);
  });
}

window.onload = (event) => {
  let pageSize = 40;
  let page = 0;
  const newsWrapper = document.getElementById("news");
  const filterWrapper = document.getElementById("filterForm");
  const backButtonWrapper = document.getElementById("backButton");
  const urlParams = new URLSearchParams(window.location.search);
  const postId = urlParams.get("post");
  const search = urlParams.get("search");
  const year = urlParams.get("year");

  const filterSettings = {
    post: postId,
    search: search || "",
    year: year || "",
  };

  if (postId) {
    filterWrapper.style.display = "none";
    backButtonWrapper.style.display = "block";
  } else {
    filterWrapper.style.display = "block";
    backButtonWrapper.style.display = "none";
  }

  showContent(page, pageSize, filterSettings);

  function loadMoreContent() {
    page++;
    showContent(page, pageSize, filterSettings);
  }

  function filter(e) {
    e.preventDefault();
    filterSettings[e.target.name] = e.target.value;

    page = 0;
    newsWrapper.textContent = "";

    showContent(page, pageSize, filterSettings);
  }

  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    const button = document.getElementById("backToTop");

    if (
      document.body.scrollTop > 300 ||
      document.documentElement.scrollTop > 300
    ) {
      button.style.display = "block";
    } else {
      button.style.display = "none";
    }
  }

  function toTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  document.getElementById("backToTop").addEventListener("click", toTop);
  document
    .getElementById("loadmore")
    ?.addEventListener("click", loadMoreContent);
  filterWrapper.addEventListener("change", filter);
  document.getElementById("searchText").addEventListener("input", filter);
};
